import { useSearchParams } from 'hooks/useSearchParams';
import { salaryComponentParams } from '../constants';
import { EarningPayType } from '../types';

export const useDetailsView = (param: string) => {
  const { addSearchParams, removeSearchParams, urlParams } = useSearchParams();

  const paramId = urlParams.get(param);
  const payType = urlParams.get(salaryComponentParams.earningPayType) as EarningPayType;
  const source = urlParams.get(salaryComponentParams.componentSource);

  const openDetailsView = (
    paramValue: number | string,
    payType?: EarningPayType,
    componentSource?: string,
  ) => {
    const newParams = [{ key: param, value: paramValue.toString() }];
    if (payType) {
      newParams.push({
        key: salaryComponentParams.earningPayType,
        value: payType,
      });
    }
    if (componentSource) {
      newParams.push({
        key: salaryComponentParams.componentSource,
        value: componentSource,
      });
    }
    addSearchParams(newParams);
  };

  const closeDetailsView = () => {
    removeSearchParams([
      param,
      salaryComponentParams.earningPayType,
      salaryComponentParams.componentSource,
    ]);
  };

  return {
    paramId,
    payType,
    source,
    openDetailsView,
    closeDetailsView,
  };
};